<template>
  <form action="#" method="post">
    <div class="form-row">
      <div class="col-md-12 mb-4">
        <div class="input_star">
          <input
            type="text"
            class="form-control"
            :class="nameError ? 'is-invalid' : ''"
            placeholder="Name"
            v-model="name"
          />
          <span class="invalid-feedback" role="alert" v-if="nameError">
            <strong>{{ nameErrorMessage }}</strong>
          </span>
        </div>
      </div>
      <div class="col-md-12 mb-4">
        <div class="input_star">
          <input
            type="text"
            class="form-control"
            :class="phoneError ? 'is-invalid' : ''"
            placeholder="Phone Number"
            v-model="phone"
          />
          <span class="invalid-feedback" role="alert" v-if="phoneError">
            <strong>{{ phoneErrorMessage }}</strong>
          </span>
        </div>
      </div>
      <div class="col-md-12 mb-4">
        <div class="input_star">
          <input
            type="email"
            class="form-control"
            :class="emailError ? 'is-invalid' : ''"
            placeholder="Email"
            v-model="email"
          />
          <span class="invalid-feedback" role="alert" v-if="emailError">
            <strong>{{ emailErrorMessage }}</strong>
          </span>
        </div>
      </div>
      <div class="col-md-12 mb-4">
        <div class="input_star">
          <input
            type="password"
            class="form-control"
            :class="passwordError ? 'is-invalid' : ''"
            placeholder="Password"
            v-model="password"
          />
          <span class="invalid-feedback" role="alert" v-if="passwordError">
            <strong>{{ passwordErrorMessage }}</strong>
          </span>
        </div>
      </div>
      <div class="col-md-12 mb-4">
        <div class="input_star">
          <input
            type="password"
            class="form-control"
            :class="passwordConfirmError ? 'is-invalid' : ''"
            placeholder="Confirm Password"
            v-model="password_confirmation"
          />
          <span class="invalid-feedback" role="alert" v-if="passwordConfirmError">
            <strong>{{ passwordConfirmErrorMessage }}</strong>
          </span>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form_submit_button">
          <button
            type="button"
            @click.prevent="registerUser"
            :disabled="processing"
            :style="processing ? 'opacity: 0.6;' : ''"
          >{{ processing ? "Processing..." : "Sign Up" }}</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import {
  required,
  email,
  sameAs,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

export default {
  name: "SellerRegister",
  data() {
    return {
      name: "",
      email: "",
      password: "",
      password_confirmation: "",
      phone: "",
      processing: false
    };
  },
  methods: {
    registerUser() {
      this.$v.$touch();
      if (this.formValid) {
        this.processing = true;
        const formData = new FormData();

        formData.append("name", this.name);
        formData.append("phone_number", this.phone);
        formData.append("email", this.email);
        formData.append("role", "seller");
        formData.append("password", this.password);
        formData.append("password_confirmation", this.password_confirmation);

        axios
          .post("/register-user", formData)
          .then(response => {
            window.location.href = "/email/verify";
          })
          .catch(error => {
              const restObj = {}
              if(error?.response?.data?.errors) {
                restObj.html = ''
                Object.values(error?.response?.data?.errors)?.forEach((err)=>{
                  restObj.html+=`<p style="color:red">${err[0]}</p>`
                })
              }
              if (error?.response?.data?.message) {
                    Swal.fire({
                    title: error?.response.data.message,
                    icon: "error",
                    timer: 3000,
                    ...restObj
                });
              }
          })
          .finally(res => {
            this.processing = false;
          });
      }
    }
  },
  computed: {
    formValid() {
      if (this.$v.$invalid) {
        return false;
      } else {
        return true;
      }
    },
    nameError() {
      if (this.$v.name.$error) {
        return true;
      } else {
        return false;
      }
    },
    nameErrorMessage() {
      if (this.nameError) {
        return "Name is required";
      } else {
        return "";
      }
    },
    emailError() {
      if (this.$v.email.$error) {
        if (!this.$v.email.required) {
          return true;
        } else if (!this.$v.email.email) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    emailErrorMessage() {
      if (this.$v.email.$error) {
        if (!this.$v.email.required) {
          return "Email is required";
        } else if (!this.$v.email.email) {
          return "Please enter a valid email address";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    passwordError() {
      if (this.$v.password.$error) {
        if (!this.$v.password.required) {
          return true;
        } else if (!this.$v.password.minLength) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    passwordErrorMessage() {
      if (this.$v.password.$error) {
        if (!this.$v.password.required) {
          return "Password is required";
        } else if (!this.$v.password.minLength) {
          return "Password must be atleast 8 characters";
        } else {
          return "";
        }
      } else {
        return false;
      }
    },
    passwordConfirmError() {
      if (this.$v.password_confirmation.$error) {
        if (!this.$v.password_confirmation.sameAs) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    passwordConfirmErrorMessage() {
      if (this.$v.password_confirmation.$error) {
        if (!this.$v.password_confirmation.sameAs) {
          return "Confirm password must be same as password";
        } else {
          return "";
        }
      } else {
        return false;
      }
    },
    phoneError() {
      if (this.$v.phone.$error) {
        if (!this.$v.phone.required) {
          return true;
        } else if (!this.$v.phone.minLength) {
          return true;
        } else if (!this.$v.phone.maxLength) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    phoneErrorMessage() {
      if (this.$v.phone.$error) {
        if (!this.$v.phone.required) {
          return "Phone number is required";
        } else if (!this.$v.phone.minLength) {
          return "Phone number must be of 10 digits";
        } else if (!this.$v.phone.maxLength) {
          return "Phone number must be of 10 digits";
        } else {
          return "";
        }
      } else {
        return "";
      }
    }
  },
  validations: {
    name: {
      required
    },
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(8)
    },
    password_confirmation: {
      sameAs: sameAs("password")
    },
    phone: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(10)
    }
  }
};
</script>